import Form from "@components/form/Form";
import useConsultancySignUpContext from "./context/useConsultancySignUpContext";
import CompletionStep from "./steps/CompletionStep";
import SignUpStep from "./steps/SignupStep";

export default function ConsultancySignUp() {
  const { handles, resetValidations, validations, setStep } = useConsultancySignUpContext();

  const [signUpHandle] = handles;

  return (
    <Form
      id="consultancy-sign-up"
      onStepChange={setStep}
      resetValidations={resetValidations}
      stepsLengthOverride={1}
      onCompletion={() => rdt("track", "SignUp")}
      validation={validations.generic}
      triggerGlobalLoading
      steps={[
        {
          children: <SignUpStep />,
          handle: signUpHandle,
        },
        {
          children: <CompletionStep />,
        },
      ]}
    />
  );
}
